import React from "react"
import useFeatureFlag, { FEATURE_CODES } from "../../hooks/useFeatureFlag"
import "./AiTargeting/AiTargeting.css"

function TotemCardItem({ totem, isAiTargetingFeatureActive }) {
  return (
    <div className="info-box bg-transparent mb-0 p-0">
      <div className="info-box-content">
        <div className="d-flex justify-content-between">
          <span className="d-flex align-items-center">
            <i className="fas fa-tv mr-2"></i> <b className="mr-2">{totem.name}</b>{" "}
            <i
              className="fas fa-circle mr-2"
              title={totem.state ? "En ligne" : "Hors ligne"}
              style={{ color: totem.state ? "green" : "red" }}
            ></i>
            {isAiTargetingFeatureActive && totem.hasAiTargeting && (
              <span
                className="badge badge-pill badge-outline-blue font-weight-bold mr-2"
                title="Totem éligible à la diffusion intelligente (IA)"
              >
                Diffusion intelligente (IA)
              </span>
            )}
          </span>
          <span>
            <i className="fas fa-broadcast-tower"></i> <em>{totem.team_totem.duration} secondes par boucle</em>
          </span>
        </div>
        <div className="d-flex justify-content-between">
          <span>
            <i className="fas fa-map-marker" style={{ width: "20px" }}></i> {totem?.address || "-"}
          </span>
          <span>
            <i className="fas fa-expand-arrows-alt"></i> {totem.width}x{totem.height}
          </span>
        </div>
      </div>
    </div>
  )
}

export default function DiffusionTotemCardTotem({ totem, isReadOnly = false, selectTotem }) {
  const { isActive: isAiTargetingFeatureActive } = useFeatureFlag(FEATURE_CODES.AI_TARGETING)

  return (
    <div className="m-3">
      {isReadOnly ? (
        <TotemCardItem totem={totem} isAiTargetingFeatureActive={isAiTargetingFeatureActive} />
      ) : (
        <button type="button" className="btn btn-block btn-light p-0" onClick={() => selectTotem(totem)}>
          <TotemCardItem totem={totem} isAiTargetingFeatureActive={isAiTargetingFeatureActive} />
        </button>
      )}
    </div>
  )
}
